import React from "react";

// region Languages
import useTranslation from "@languages/useTranslation";
import { AnnouncementMessages } from "@languages/interfaces";
// endregion Languages
// region Hooks
import { useStaffPermissions } from "@hooks/useStaffPermissions";
// endregion Hooks
// region Atoms
import AccessDenied from "@atoms/AccessDenied";
// endregion Atoms
// region Organisms
import AnnouncementsDashboard from "@organisms/AnnouncementsDashboard";
// endregion Organisms
// region Styles
import * as Styled from "./styles";
// endregion Styles

/**
 * Announcements admin area. The route is already admin-only (PrivateRoute
 * onlyAdmin); this page additionally requires the ANNOUNCEMENTS_MANAGE staff
 * permission — not every Topcon admin may publish. The same rule is enforced
 * server-side on every management operation; this gate is UX only. A failed
 * permission lookup is reported as an error (with retry), never as a denial.
 */
const Notifications: React.FC = () => {

  const { t } = useTranslation();
  const {
    canManageAnnouncements, loading, error, refetch
  } = useStaffPermissions();

  if (loading) return null;

  if (error) {
    return (
      <Styled.Container>
        <Styled.ErrorState>
          <span>{t(AnnouncementMessages.loadError)}</span>
          <Styled.RetryButton type="button" onClick={refetch}>
            {t(AnnouncementMessages.retry)}
          </Styled.RetryButton>
        </Styled.ErrorState>
      </Styled.Container>
    );
  }

  if (!canManageAnnouncements) return <AccessDenied />;

  return (
    <Styled.Container>
      <AnnouncementsDashboard />
    </Styled.Container>
  );
};

export default Notifications;
